import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { listTemplates, fetchCampaign, createCampaignApi, updateCampaignTemplatesApi, createTemplateApi, listCampaignsApi, presign, addKbFileToCampaign, deleteKbFileFromCampaign } from '../api/api';
import ConfirmationModal from '../components/ConfirmationModal';
import DeleteConfirmationModal from '../components/DeleteConfirmationModal';
import { FaTimes } from 'react-icons/fa';
import {FileUpload} from "@cloudscape-design/components"
import axios from 'axios';

const CampaignEditor = ({ setAlert }) => {
  const navigate = useNavigate();
  const { name } = useParams();
  const [campaignName, setCampaignName] = useState('');
  const [templates, setTemplates] = useState([]); // all templates
  const [selected, setSelected] = useState([]); // selected template names
  const [initial, setInitial] = useState([]);
  const [newTemplates, setNewTemplates] = useState([]); // templates created inline
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveConfirm, setSaveConfirm] = useState(false);
  const [allCamps, setAllCamps] = useState('')
  const [inputError, setInputError] = useState([false]);
  const [upload, setUpload] = useState([])
  const [kbFiles, setKbFiles] = useState([]);
  const [deleteKbInfo, setDeleteKbInfo] = useState({ open: false, fileId: null });

    const handleFileAdd = ({ detail }) => {
    const newFiles = detail.value;
    setUpload(newFiles);
    // console.log("UPLOAD: ", upload)
  };

  useEffect(() => {
    const load = async () => {
      try {
        const tmplRes = await listTemplates();
        setTemplates(tmplRes.templates || []);
        const res = await listCampaignsApi();
        setAllCamps(res.campaigns)
        if (name) {
          const campRes = await fetchCampaign(name);
          setCampaignName(campRes.campaignName);
          setSelected(campRes.templates || []);
          setInitial(campRes.templates || []);
          setKbFiles(campRes.kbFiles || []);
        }
      } catch (err) {
        console.error('Failed to load data', err);
        setAlert?.({ variant: 'error', heading: 'Error', text: 'Failed to load campaign.' });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [name]);
  

  const toggle = (t) => {
    setSelected(s => s.includes(t) ? s.filter(x => x !== t) : [...s, t]);
  };

  const addTemplate = () => {
    setNewTemplates(t => [
      ...t,
      {
        templateName: '',
        questions: [{ questionName: '', description: '',expected: '', type: 'Compliance', weight: ''  }]
      }
    ]);
  };

  const updateTemplate = (index, key, value) => {
    setNewTemplates(t => t.map((tpl, i) => i === index ? { ...tpl, [key]: value } : tpl));
  };

  const addQuestion = (tplIndex) => {
    setNewTemplates(t => t.map((tpl, i) =>
      i === tplIndex ? { ...tpl, questions: [...tpl.questions, { questionName: '', description: '',expected: "", type: 'Compliance', weight: '' }] } : tpl
    ));
  };

  const updateQuestion = (tplIndex, qIndex, key, value) => {
    setNewTemplates(t => t.map((tpl, i) =>
      i === tplIndex ? { ...tpl, questions: tpl.questions.map((q, qi) => qi === qIndex ? { ...q, [key]: value } : q) } : tpl
    ));
  };

  const removeQuestion = (tplIndex, qIndex) => {
    setNewTemplates(t => t.map((tpl, i) =>
      i === tplIndex ? { ...tpl, questions: tpl.questions.filter((_, qi) => qi !== qIndex) } : tpl
    ));
  };

  const removeTemplate = (index) => {
    setNewTemplates(t => t.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
        for (let i =0; i<= allCamps.length -1 ; i++) {
          if (allCamps[i].campaignName === campaignName && name != allCamps[i].campaignName) {
            setInputError([true, `Campaign name '${allCamps[i].campaignName}' already exists.`])
            setSaveConfirm(false);
            return;
          }      
        }
      if (!name) {
        const createdNames = [];
        for (const tpl of newTemplates) {
          if (!tpl.templateName.trim()) throw new Error('Scorecard name required');
          await createTemplateApi({ templateName: tpl.templateName, campaign: campaignName, questions: tpl.questions });
          createdNames.push(tpl.templateName);
        }
        await createCampaignApi({ campaignName, templates: [...selected, ...createdNames] });
        // Upload knowledge base files after campaign is created
        if (upload.length != 0 ){
          for (let i=0; i <= upload.length - 1; i++) {
              let filename = upload[i].name
              let s3Up = await presign(filename, `knowledgebase`, campaignName)
              await axios.put(s3Up.url, upload[i])
              console.log(`S3 presign URL for ${filename} : ${s3Up}`)
              // Register the file in KB management system linked to this campaign
              await addKbFileToCampaign(campaignName, filename, s3Up.key || filename);
          }
        }
      } else {
        const createdNames = [];
        for (const tpl of newTemplates) {
          if (!tpl.templateName.trim()) throw new Error('Scorecard name required');
          await createTemplateApi({ templateName: tpl.templateName, campaign: campaignName, questions: tpl.questions });
          createdNames.push(tpl.templateName);
        }
        if (upload.length != 0 ){
          for (let i=0; i <= upload.length - 1; i++) {
              let filename = upload[i].name
              let s3Up = await presign(filename, `knowledgebase`, campaignName)
              await axios.put(s3Up.url, upload[i])
              console.log(`S3 presign URL for ${filename} : ${s3Up}`)
              // Register the file in KB management system linked to this campaign
              await addKbFileToCampaign(campaignName, filename, s3Up.key || filename);
          }
        }
        const toAdd = [...selected, ...createdNames].filter(t => !initial.includes(t));
        const toRemove = initial.filter(t => ![...selected, ...createdNames].includes(t));
        for (const t of toAdd) {
          await updateCampaignTemplatesApi(campaignName, { templateName: t, action: 'add' });
        }
        for (const t of toRemove) {
          await updateCampaignTemplatesApi(campaignName, { templateName: t, action: 'remove' });
        }
      }
      setUpload([])
      setAlert?.({ variant: 'success', heading: 'Campaign Saved', text: 'Campaign saved successfully.' });
      navigate('/campaigns');
    } catch (err) {
      console.error('Save failed', err);
      setAlert?.({ variant: 'error', heading: 'Error', text: 'Failed to save campaign.' });
    } finally {
      setSaving(false);
    }
  };

  // Delete KB file handler
  const handleDeleteKbFile = async () => {
    if (!deleteKbInfo.fileId || !name) return;
    try {
      await deleteKbFileFromCampaign(name, deleteKbInfo.fileId);
      setKbFiles(files => files.filter(f => f !== deleteKbInfo.fileId));
      setAlert?.({ variant: 'success', heading: 'File Deleted', text: 'Knowledge base file deleted successfully.' });
    } catch (err) {
      console.error('Failed to delete KB file', err);
      setAlert?.({ variant: 'error', heading: 'Error', text: 'Failed to delete knowledge base file.' });
    } finally {
      setDeleteKbInfo({ open: false, fileId: null });
    }
  };

  if (loading) return <div className="text-center mt-20 text-gray-500">Loading...</div>;

  return (
    <>
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">{name ? 'Edit Campaign' : 'New Campaign'}</h1>
      </div>
      <div className="card space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Name</label>
          <input value={campaignName} onChange={e=>setCampaignName(e.target.value)} className="input-field" disabled={!!name} />
        </div>
        {/* Knowledge Base Files Section */}
        <div className="border-t pt-4 mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Knowledge Base Files
          </label>
          {/* Display attached KB files */}
          {name && kbFiles.length > 0 && (
            <div className="mb-4">
              <p className="text-xs text-gray-500 mb-2">Attached files:</p>
              <ul className="space-y-2">
                {kbFiles.map((fileId) => (
                  <li key={fileId} className="flex items-center justify-between bg-gray-50 p-2 rounded border">
                    <span className="text-sm text-gray-700">{fileId}</span>
                    <button
                      type="button"
                      onClick={() => setDeleteKbInfo({ open: true, fileId })}
                      className="text-red-600 hover:text-red-800 p-1"
                      title="Delete file"
                    >
                      <FaTimes />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {name && kbFiles.length === 0 && (
            <p className="text-xs text-gray-500 mb-2">No knowledge base files attached.</p>
          )}
          {/* Upload new files */}
          <p className="text-xs text-gray-500 mb-2">Upload new files:</p>
          <FileUpload
              onChange={handleFileAdd}
              value={upload}
              i18nStrings={{
              uploadButtonText: e =>
                  e ? "Upload examples" : "Upload example",
              dropzoneText: e =>
                  e
                  ? "Drop files to upload"
                  : "Drop file to upload",
              removeFileAriaLabel: e =>
                  `Remove file ${e + 1}`,
              limitShowFewer: "Show fewer files",
              limitShowMore: "Show more files",
              errorIconAriaLabel: "Error",
              warningIconAriaLabel: "Warning"
              }}
              multiple
              showFileLastModified
              showFileSize
              showFileThumbnail
              tokenLimit={3}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Scorecards</label>
          <div className="space-y-2">
            {templates.map(t => (
              <label key={t.templateName} className="flex items-center space-x-2">
                <input type="checkbox" checked={selected.includes(t.templateName)} onChange={()=>toggle(t.templateName)} />
                <span>{t.templateName}</span>
              </label>
            ))}
          </div>
          {newTemplates.map((tpl, idx) => (
            <div key={idx} className="border border-gray-200 rounded-lg p-4 mt-4 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Scorecard Name</label>
                <input value={tpl.templateName} onChange={e=>updateTemplate(idx,'templateName',e.target.value)} className="input-field" />
              </div>
              <div className="space-y-4">
                {tpl.questions.map((q, qIdx) => (
                  <div key={qIdx} className="border border-gray-100 rounded p-3 space-y-2">
                    <input
                      value={q.questionName}
                      onChange={e=>updateQuestion(idx,qIdx,'questionName',e.target.value)}
                      className="input-field"
                      placeholder="Question Name"
                    />
                    <textarea
                      rows="2"
                      value={q.description}
                      onChange={e=>updateQuestion(idx,qIdx,'description',e.target.value)}
                      className="input-field w-full"
                      placeholder="Description"
                    />
                    <textarea
                      rows="2"
                      value={q.expected}
                      onChange={e=>updateQuestion(idx, qIdx,'expected', e.target.value)}
                      className="input-field w-full"
                      placeholder="Expected"
                    />
                    <select
                      value={q.type}
                      onChange={e=>updateQuestion(idx,qIdx,'type',e.target.value)}
                      className="select-field"
                    >
                      <option value="Compliance">Compliance</option>
                      <option value="Quality">Quality</option>
                    </select>
                    {q.type == 'Quality' && (
                      <input
                        type="number"
                        value={q.weight}
                        onChange={e=>updateQuestion(idx,qIdx,'weight',e.target.value)}
                        className="input-field"
                        placeholder="Weight"
                      />                      
                    )}
                    <br/><br/>
                    <button onClick={()=>removeQuestion(idx,qIdx)} className="btn-outline text-red-600 border-red-300 hover:bg-red-50">Remove Question</button>
                  </div>
                ))}
                <button onClick={()=>addQuestion(idx)} className="btn-outline">Add Question</button>
              </div>
              <button onClick={()=>removeTemplate(idx)} className="btn-outline text-red-600 border-red-300 hover:bg-red-50">Remove Scorecard</button>
            </div>
          ))}
          <button onClick={addTemplate} className="btn-outline mt-2">Create New Scorecard</button>
        </div>
        {inputError[0] && (
          <div className="custom-alert">
            <span>{inputError[1]}</span>
            <button className="dismiss-btn" onClick={() => setInputError([false])}>
              <FaTimes />
            </button>
          </div>
        )}  
        <div className="flex justify-end">
          <button onClick={() => setSaveConfirm(true)} disabled={saving} className="btn-primary">
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
    <ConfirmationModal
      open={saveConfirm}
      title="Save Confirmation"
      message={`Are you sure you want to save the changes to ${campaignName || 'this campaign'}?`}
      confirmText="Confirm Save"
      onClose={() => setSaveConfirm(false)}
      onConfirm={handleSave}
    />
    <DeleteConfirmationModal
      open={deleteKbInfo.open}
      itemName={deleteKbInfo.fileId || ''}
      onClose={() => setDeleteKbInfo({ open: false, fileId: null })}
      onConfirm={handleDeleteKbFile}
    />
    </>
  );
};

export default CampaignEditor;